import React, { useState, useEffect, useContext, useRef } from 'react'
import Wrapper from '../../../components/common/Wrapper/Wrapper'
import organisms from '../../../components/organisms'
import molecules from '../../../components/molecules'
import { ShowActiveTab } from '../../../Context';
import { useToasts } from 'react-toast-notifications';
import constant from '../../../constants/constant';
import service from '../../../api/services'
import { BarcodeDataProps, ErrorsProps, SkuOptionsProps } from './interface';
import { getDropdown } from '../../../constants/utils';
import { validationRules } from './validation';

const { InventoryAudit } = organisms
const { TopBar } = molecules


const Index = () => {
    const { setActiveTab }: any = useContext(ShowActiveTab)
    const searchTabContainer = useRef<HTMLDivElement>(null);
    const [barcodeData, setBarcodeData] = useState<BarcodeDataProps | null>(null)
    const [inventoryItemCondition, setInventoryItemCondition] = useState<SkuOptionsProps[]>()
    const [skuOptions, setSkuOptions]=useState<SkuOptionsProps[]>()
    const [updateData, setUpdateData] = useState<any>({
        item_condition: null,
        conditionRemark: '',
        sku:null
    })
    const [errors, setErrors] = useState<ErrorsProps | null>(null)

    const { addToast } = useToasts();


    const getDropdownList = (options: any, threshold: number) => {
        let dropdown: any = [];

        if (threshold) {
            options.map((item: { label: string, value: number }) => {
                if (item?.value >= threshold) {
                    dropdown.push({
                        "value": item.value,
                        "label": item.label
                    });
                }
            });
        } else {
            return constant?.INVENTORY_ITEM_CONDITION;
        }

        return dropdown;
    };


    const handleBarcodeSearch = async (search: string) => {
        try {
            const response = await service.Audit.barcodeSearchApi({ search: search })
            if (response.status === 200) {
                getSkuList()
                setBarcodeData(response?.data?.data)
                setUpdateData({ ...updateData, item_condition: null, conditionRemark: '', sku:null })
                setInventoryItemCondition(getDropdownList(constant?.INVENTORY_ITEM_CONDITION, response?.data?.data?.audit_trails[0]?.new_audit_status))
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });

        }
    }

    const updateItemCondition = async (id: string) => {
        const payload = {
            "item_condition": updateData.item_condition.value,
            "condition_remark": updateData.conditionRemark,
            "sku_id":updateData.sku.value
        }
        try {
            const response = await service.Audit.updateItemCondition(id, payload)
            if (response.status === 200) {
                // handleBarcodeSearch(searchValue)
                setBarcodeData(null)
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                if (searchTabContainer?.current) {
                    const inputElement = searchTabContainer.current.querySelector('input');
                    if (inputElement) {
                        (inputElement as HTMLInputElement).value = '';
                    }
                }
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const getSkuList = async () => {
        try {
            const response = await service.sku.list()
            if (response.status === 200) {
                setSkuOptions(getDropdown(response?.data?.data,"sku_number"))
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });

        }
    }

    const handleChange = (name: string, value: any) => {
        setUpdateData({ ...updateData, [name]: value })
    }

    // for validation for inventory audit
    const validate = () => {
        let newErrors: any = {};
        const rules: any =  validationRules
        for (const field in rules) {
            if (rules.hasOwnProperty(field)) {
                if (rules[field]?.required && (!updateData[field] || updateData[field]?.length === 0)) {
                    newErrors[field] = "This field is required.";
                } 
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // end

    const handleSubmit=(id:string)=>{
        const isValid = validate();
        if (isValid) {
            updateItemCondition(id)
        }
    }

    useEffect(() => { setActiveTab("InventoryAudit") }, [])
    return (
        <Wrapper>
            <div className=''>
                <div className='row align-items-center'>
                    <TopBar heading={'Inventory Audit'} />
                </div>
                <InventoryAudit
                    handleBarcodeSearch={(search: string) => handleBarcodeSearch(search)}
                    updateItemCondition={(id:string)=>handleSubmit(id)}
                    barcodeData={barcodeData}
                    handleChange={handleChange}
                    updateData={updateData}
                    inventoryItemCondition={inventoryItemCondition}
                    searchTabContainer={searchTabContainer}
                    skuOptions={skuOptions}
                    errors={errors}
                />
            </div>
        </Wrapper>
    )
}

export default Index